const prepareShow = guest => {
  return guest
}

const prepareSave = guest => {
  guest.country_register = guest.country_register.replace('-', '')
  return guest
}

export default {
  prepareSave,
  prepareShow,
  afterCreated () {
    this.$toast.success('Lista incluida com sucesso.')
    return this.$router.push({name: 'dweller.guest.index'})
  },
  afterUpdated () {
    this.$toast.success('Lista alterada com sucesso.')
    return this.$router.push({name: 'dweller.guest.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  doSaveList () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }

    const params = {
      name: this.person.name,
      country_register: this.person.country_register,
      contact_phone_first: this.person.contact_phone_first,
      dweller_guest_list_id: this.person.dweller_guest_list_id
    }
    this.loading = true
    this.$http.post('/v1/dweller/guest/list/person', params)
      .then((data) => {
        if (data.id) {
          this.$nextTick(() => { this.$v.$reset() })
          this.person.name = null
          this.person.country_register = null
          this.person.contact_phone_first = null
          this.getPersons()
        }
      })
      .catch((er) => {
        this.errors = er.data
        this.afterFailure(er)
      })
  },
  doDelete (p, idx) {
    this.loading = true
    this.$http.delete('/v1/dweller/guest/list/person/' + p.id)
    .then((data) => {
      this.getPersons()
    })
    .catch((er) => {
      this.errors = er.data
      this.afterFailure(er)
    })
  },
  getPersons () {
    this.$http.get('/v1/dweller/guest/list/person/' + this.person.dweller_guest_list_id)
    .then((data) => {
      if (data) {
        this.persons = data
        this.loading = false
      }
    })
    .catch((er) => {
      this.errors = er.data
      this.afterFailure(er)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/guest/list/resources/methods.js